import { useFormikContext } from 'formik';
import React from 'react';
import { ODAppOptions } from '../../../../utils';
export function ODEntityEditorHeader(_a) {
    var title = _a.title, populateDevData = _a.populateDevData;
    var enableDevOptions = ODAppOptions.FILL_MOCK_DATA;
    var setFieldValue = useFormikContext().setFieldValue;
    var update = React.useCallback(function () {
        if (enableDevOptions && populateDevData) {
            var values_1 = populateDevData();
            Object.keys(values_1).forEach(function (key) {
                // @ts-ignore
                setFieldValue(key, values_1[key]);
            });
        }
    }, [populateDevData, enableDevOptions, setFieldValue]);
    var style = enableDevOptions ? { cursor: 'pointer' } : {};
    return (React.createElement("strong", { style: style, onClick: update }, title));
}
//# sourceMappingURL=ODEntityEditorHeader.js.map